import { AllTokens } from "gql/graphql";
import { ReactNode } from "react";
import { Guard } from "@/shared/security/model/guard/guard";

/** Раздел справочников целиком: список, справочник и правка его значений. */
export function RestrictDictionaries({ children }: { children: ReactNode }) {
  return (
    <Guard.Redirect.IfCantModify.PageNotFound
      influencedBy={[AllTokens.AdminCompanyDictionaries]}
    >
      {children}
    </Guard.Redirect.IfCantModify.PageNotFound>
  );
}
